import React, { useState } from "react";

const services = [
  {
    title: "Energieausweis",
    subtitle: "Klarheit über den energetischen Zustand deiner Immobilie",
    text: `Der Energieausweis ist ein zentrales Dokument, wenn es um den Verkauf, die Vermietung oder die energetische Bewertung eines Gebäudes geht. Wir erstellen deinen Energieausweis fachgerecht und sorgen dafür, dass alle gesetzlichen Anforderungen erfüllt sind - damit du auf der sicheren Seite bist`,
    bullets: [
      "Prüfung der Ausweispflicht und des passenden Ausweistypen",
      "Fachgerechte Berechnung nach aktueller Gesetzeslage (GEG)",
      "Ausstellung eines gültigen Energieausweises für Wohngebäude"
    ]
  },
  {
    title: "Heizlastberechnung",
    subtitle: "Die Grundlage für ein effizientes Heizsystem",
    text: `Eine exakte Heizlastberechnung ist entscheidend für die richtige Auslegung deiner Heizungsanlage. Egal ob im Neubau oder bei einer Sanierung, wir sorgen dafür, dass deine Anlage genau zu deinem Gebäude und deinem Bedarf passt`,
    bullets: [
      "Präzise Heizlastberechnung für Wohngebäude und Neubauten",
      "Grundlage für die Auslegung von Wärmepumpen, Heizkörpern oder Fußbodenheizungen",
      "Berücksichtigung energetischer Standards und Förderbedingungen",
      "Vermeidung von Überdimensionierung oder Unterversorgung",
      "Fachlich fundierte Beratung bei der Heizsystemwahl"
    ]
  },
  {
    title: "KfW-Effizienzhaus",
    subtitle: "Fördermittel optimal nutzen, Gebäude zukunftssicher machen",
    text: `Ein KfW-Effizienzhaus steht für hohe energetische Qualität und langfristige Energieeinsparung. Egal ob Neubau oder Sanierung, wir unterstützen dich dabei, die Anforderungen zu erfüllen und von attraktiven Förderungen zu profitieren`,
    bullets: [
      "Beratung zu KfW-Effizienzhaus-Standards für Neubau und Sanierung",
      "Individuelle Maßnahmenplanung zur Zielerreichung (inkl. iSFP bei Sanierung)",
      "Wirtschaftlichkeits- und Fördermittelberatung",
      "Erstellung der Bestätigung zum Antrag (BzA) für die BEG-Förderung",
      "Begleitung der Umsetzung als qualifizierter Energieeffizienz-Experte"
    ]
  },
  {
    title: "Sanierungsfahrplan (iSFP)",
    subtitle: "Schritt für Schritt zur energieeffizienten Immobilie",
    text: `Viele Eigentümer möchten ihr Haus energetisch sanieren, wissen aber oft nicht, wo sie anfangen sollen. Mit einem individuellen Sanierungsfahrplan helfen wir dir dabei, den Überblick zu behalten und Schritt für Schritt die richtigen Entscheidungen zu treffen`,
    bullets: [
      "Klare Übersicht über sinnvolle Sanierungsschritte",
      "Verständlich aufbereiteter Bericht mit Maßnahmen, Kosten und Einsparpotenzial",
      "Grundlage für staatliche Fördermittel (z. B. zusätzliche 5 % Förderung im Rahmen der BEG)",
      "Kein Zwang zur sofortigen Umsetzung – Planungssicherheit für die nächsten Jahre",
      "Neutral, unabhängig und auf Ihre Immobilie abgestimmt"
    ]
  },
  {
    title: "Energieberatung",
    subtitle: "Dein erster Schritt zur effizienten Immobilie",
    text: `Energie ist kostbar, und genau deshalb lohnt es sich, beim Thema Energieeffizienz genauer hinzusehen. Eine unabhängige Energieberatung hilft dir dabei, Einsparpotenziale zu erkennen, Maßnahmen gezielt zu planen und langfristig Kosten zu senken`,
    bullets: [
      "Analyse des Ist-Zustands deines Gebäudes",
      "Individuelle Empfehlungen zu Dämmung, Heiztechnik und erneuerbaren Energien",
      "Beratung zu gesetzlichen Anforderungen (GEG) und Fördermöglichkeiten (BEG, KfW, BAFA)",
      "Unterstützung bei Planung, Förderantrag und Umsetzung",
      "Auf Wunsch: Erstellung eines individuellen Sanierungsfahrplans (iSFP)"
    ]
  }
];

const ServiceCard = ({ title, subtitle, text, bullets }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="service-card container">
      <button
        className="accordion-header"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <div>
          <h2>{title}</h2>
          <h3>{subtitle}</h3>
        </div>
        <span className={`arrow ${open ? "rotate" : ""}`}>▼</span>
      </button>
      {open && (
        <div className="accordion-content">
          <p>{text}</p>
          <ul>
            {bullets.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export const Leistungen = () => {
  return (
    <section className="leistungen">
      <div className="text-center mb-12">
        <h1>Meine Leistungen</h1>
        <p className="intro">
          Kompetente Unterstützung rund um Energieeffizienz, Förderungen und Modernisierung
        </p>
      </div>
      {services.map((service, index) => (
        <ServiceCard key={index} {...service} />
      ))}
    </section>
  );
};
